var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"text-center mt-28"},[_c('h1',{staticClass:"font-bold text-3xl"},[_vm._v(_vm._s(this.title))]),_c('p',{staticClass:"text-sm mt-2"},[_vm._v(_vm._s(this.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }